import { setPagination } from '../../../State/pagination'
import fetch from '../../../Services/fetch'

export default () => (dispatch) => {

  dispatch(setPagination({ current: 1 }))

  dispatch(fetch())
  
}